import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requireCircle }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-bone flex items-center justify-center pt-20">
        <p className="font-body text-slate">Loading...</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (requireCircle && !user.circle_member && user.role !== "admin") {
    return <Navigate to="/dispatch-circle" replace />;
  }

  return children;
}
